import $ from 'jquery';

(() => {

  const contents = '_accordion';

  $(function(){

    $('.accordion').on('click',function(){
      console.log("accordion");
      $(this).parent().toggleClass('open');
    });

  });

})();
